// extracted by mini-css-extract-plugin
module.exports = {"chat_container":"chat-return_chat_container__NFcag","chat_container_left":"chat-return_chat_container_left__yGATI","chat_container_right":"chat-return_chat_container_right__a8Z8D"};